import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { requestPending } from "../../../constants/constants";

const namespace = 'removeSaleDialog'
const initialState = {
    isOpen:false,
    id:0,
    status: requestPending
}

export const removeSaleDialog
 = createSlice({
    name : namespace,
    initialState : initialState,
    reducers:{
        openRemoveDialog: (state,action) => {
            state.id = action.payload;
            state.isOpen = true;
        },
        closeRemoveDialog:(state) => {
            state.isOpen = false;
        },
    },
})

export const removeSaleDialogReducer = removeSaleDialog.reducer;
export const { openRemoveDialog, closeRemoveDialog } = removeSaleDialog.actions;